/**
 * La captura de pantalla (snapDOM) vive aparte y solo se descarga al enviar una nota con captura: así
 * el widget pesa poco en todas las páginas del sitio. Con `<script>`, es el archivo `w-shot.js`; en el
 * paquete npm, un trozo que se carga con import().
 */

export interface ShotRequest {
  /** Selectores que no salen en la captura (el propio widget, contraseñas, datos marcados). */
  exclude: string[];
  /** Rectángulo del elemento señalado, en coordenadas de la ventana: se marca sobre la imagen. */
  highlight?: { x: number; y: number; width: number; height: number };
  /** O un punto (nota sobre un sitio concreto de un bloque grande): se dibuja un pin. */
  pin?: { x: number; y: number };
  color: string;
}
export type CaptureFn = (req: ShotRequest) => Promise<Blob | null>;

let loading: Promise<CaptureFn> | null = null;
let resolveLoad: ((fn: CaptureFn) => void) | null = null;

/** Lo llama `w-shot.js` al cargarse. */
export function registerShot(fn: CaptureFn): void {
  resolveLoad?.(fn);
}

/** Para el widget de `<script>`: carga `w-shot.js` del servidor de Anota. */
export function loadShotScript(base: string, nonce?: string): Promise<CaptureFn> {
  loading ??= new Promise<CaptureFn>((resolve, reject) => {
    resolveLoad = resolve;
    const script = document.createElement("script");
    script.src = `${base}/w-shot.js`;
    script.async = true;
    if (nonce) script.nonce = nonce;
    script.onerror = () => {
      loading = null;
      reject(new Error("No se pudo cargar w-shot.js"));
    };
    document.head.appendChild(script);
  });
  return loading;
}

/** Una promesa que no tarda más de `ms`: una página enorme no puede dejar la nota esperando. */
export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T | null> {
  return Promise.race([promise, new Promise<null>((resolve) => setTimeout(() => resolve(null), ms))]);
}
